const createIdFromName = (name: string) => name.replace(/\s+/g, "-").toLowerCase()
export default createIdFromName
